import { render } from "./pagination.vue?vue&type=template&id=68140b2e&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=68140b2e&scoped=true&lang=css"

import exportComponent from "D:\\vue\\不同模板项目\\template\\chengshineilao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68140b2e"]])

export default __exports__